"use strict";

var _Box, _AsyncBoundary, _Column, _Column2, _Column3;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { c as _c } from "react/compiler-runtime";
import { UserMenuHolder } from '@autoguru/components';
import { AsyncBoundary } from '@autoguru/suspense';
import { Box, Column, Columns, useMedia } from '@autoguru/overdrive';
import { lazy } from 'react';
import { HeaderLayout } from '@autoguru/header-layout';
import { Picture } from '@autoguru/picture';
import { CDN } from '@autoguru/global-configs';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const pageHeaderPortalId = '__ag-header__';
const AppSideHandle = /*#__PURE__*/lazy(async () => import('@autoguru/components/components/AppAsideHandle/AppSideHandle'));
const LogoImage = /*#__PURE__*/_jsx(Picture, {
  aspectRatio: 5.1,
  height: 24,
  backgroundColor: "transparent",
  src: `${CDN}/images/logos/autoguru.svg`,
  altText: "AutoGuru logo"
});
export const AppHeader = () => {
  const $ = _c(9);
  if ($[0] !== "a27be08f5f7acb544a6b704ed664346f5844675f1250b81974efcb77dd58a414") {
    for (let $i = 0; $i < 9; $i += 1) {
      $[$i] = Symbol.for("react.memo_cache_sentinel");
    }
    $[0] = "a27be08f5f7acb544a6b704ed664346f5844675f1250b81974efcb77dd58a414";
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["tablet"];
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [notMobile] = useMedia(t0, false);
  let t1;
  if ($[2] !== notMobile) {
    t1 = /*#__PURE__*/_jsx(Column, {
      noShrink: true,
      alignSelf: "centre",
      children: notMobile ? _Box || (_Box = /*#__PURE__*/_jsx(Box, {
        is: "a",
        href: "/",
        children: LogoImage
      })) : _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
        fallback: null,
        children: /*#__PURE__*/_jsx(AppSideHandle, {})
      }))
    });
    $[2] = notMobile;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = _Column || (_Column = /*#__PURE__*/_jsx(Column, {
      grow: true,
      alignSelf: "centre",
      children: /*#__PURE__*/_jsx("span", {})
    }));
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(Column, {
      grow: true,
      alignSelf: "centre",
      children: /*#__PURE__*/_jsxs(Columns, {
        width: "full",
        space: "3",
        children: [t2, _Column2 || (_Column2 = /*#__PURE__*/_jsx(Column, {
          noShrink: true,
          alignSelf: "centre",
          children: /*#__PURE__*/_jsx("span", {})
        }))]
      })
    });
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = _Column3 || (_Column3 = /*#__PURE__*/_jsx(Column, {
      noShrink: true,
      alignSelf: "centre",
      children: /*#__PURE__*/_jsx(UserMenuHolder, {})
    }));
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1) {
    t5 = /*#__PURE__*/_jsx(HeaderLayout, {
      safePaddings: true,
      children: /*#__PURE__*/_jsxs(Columns, {
        space: "5",
        children: [t1, t3, t4]
      })
    });
    $[7] = t1;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};